import { DateRange } from "react-day-picker";
import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import {
  DateFilterOption,
  HttpResponse,
  LeaderboardQueryParams,
  LeaderboardUser,
} from "@/types";

const prepareDateRangeQueryParams = (
  queryParams: URLSearchParams,
  dateRange?: DateRange,
) => {
  if (dateRange?.from) {
    queryParams.append("startDate", String(dateRange.from));
  }
  if (dateRange?.to) {
    // End date must be set to the following day to include the entire day
    // We handle this logic here so that the date range on the date range picker can be displayed correctly.
    // More info in dates.handleDateRangeFilter().
    const endDate = new Date(dateRange.to);
    endDate.setDate(endDate.getDate() + 1);
    queryParams.append("endDate", String(endDate));
  }
};

export function useGetLeaderboard(queryOptions: LeaderboardQueryParams) {
  return useQuery({
    queryKey: ["leaderboard", queryOptions],
    queryFn: async () => {
      const { dateRange, timePeriod } = queryOptions;
      const queryParams = new URLSearchParams();

      if (timePeriod === DateFilterOption.Custom) {
        prepareDateRangeQueryParams(queryParams, dateRange);
      } else {
        queryParams.set("period", timePeriod);
      }

      const path = `staffer-metrics?${queryParams.toString()}`;
      const res = await guacHttpClient.get<
        LeaderboardUser[],
        HttpResponse<LeaderboardUser[]>
      >(path);

      return res.data;
    },
    placeholderData: (previousData) => previousData,
  });
}
